<template>
  <div>
    <side-bar
      v-if="user"
      :active-color="sidebarBackground"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Challenges',
            icon: 'emoji_events',
            path: '/Challenges'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Feed', icon: 'dashboard', path: '/Feed' }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="user"
          @click.native="logout"
          :link="{
            name: 'Logout',
            icon: 'exit_to_app',
            path: '/Login'
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <router-view></router-view>
    <div id="mobile-menu" v-if="user">
      <div class="phone-viewport">
        <md-bottom-bar md-sync-route>
          <md-bottom-bar-item
            to="/Challenges"
            exact
            md-label="Challenges"
            md-icon="emoji_events"
          ></md-bottom-bar-item>
          <md-bottom-bar-item
            to="/Feed"
            exact
            md-label="Feed"
            md-icon="dashboard"
          ></md-bottom-bar-item>
          <md-bottom-bar-item
            :to="`/pages/user/${user._id}`"
            md-label="User"
            md-icon="account_circle"
          ></md-bottom-bar-item>
          <md-bottom-bar-item
            v-if="user"
            @click.native="logout"
            to="/Login"
            md-label="Logout"
            md-icon="exit_to_app"
          ></md-bottom-bar-item>
        </md-bottom-bar>
      </div>
    </div>
    <notifications></notifications>
  </div>
</template>

<script>
import TopNavbar from "./pages/Layout/TopNavbar.vue";
import ContentFooter from "./pages/Layout/ContentFooter.vue";
import UserMenu from "./pages/Dashboard/Layout/Extra/UserMenu.vue";
import { mapState } from "vuex";

export default {
  components: {
    UserMenu
  },
  data() {
    return {
      sidebarBackgroundColor: "white",
      sidebarBackground: "green",
      sidebarMini: true,
      sidebarImg: true
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/").catch(err => {
          console.log(err);
          throw new Error(`Problem handling something: ${err}.`);
        });
        // this.$notify({
        //   timeout: 5000,
        //   message: "Du bist jetzt abgemeldet!",
        //   icon: "add_alert",
        //   horizontalAlign: "right",
        //   verticalAlign: "top",
        //   type: "success"
        // });
      });
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
    user(val) {
      if (val) {
        this.$i18n.locale = val.language;
      }
    }
  }
};
</script>

<style>
@media (min-width: 960px) {
  #mobile-menu {
    display: none;
  }
}

.phone-viewport {
  width: 100%;
  display: inline-flex;
  align-items: flex-end;
  overflow: hidden;
  border: 1px solid rgba(#000, 0.26);
  background: rgba(#000, 0.06);
}

@media (max-width: 991px) {
  #mobile-menu {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 999999;
    background-color: #999999;
  }
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
